import { z } from 'zod';

export type EmailErrorMessages = {
  required?: string;
  invalid?: string;
};

const DEFAULT_ERROR_MESSAGES = {
  required: 'Email is required',
  invalid: 'Please enter a valid email address',
};

export const createEmailSchema = (customErrorMessages: Partial<EmailErrorMessages> = {}) => {
  const errorMessages = { ...DEFAULT_ERROR_MESSAGES, ...customErrorMessages };
  return z.string().min(1, errorMessages.required).email(errorMessages.invalid);
};
